import {ref} from "vue";

const storageKey = 'boothy:apiAuth'

const galleryAuth = ref<string|null>(localStorage.getItem(storageKey))

const setGalleryAuth = (val:string) => {
    galleryAuth.value = btoa(val)
    localStorage.setItem(storageKey, galleryAuth.value)
}

const hasGalleryAuth = () => {
    return galleryAuth.value !== null && galleryAuth.value !== ""
}

export {
    galleryAuth,
    setGalleryAuth,
    hasGalleryAuth
}